const required = {
    name: "required",
    validate: (value) => value != null && value !== "",
};
exports.required = required;
exports.required1 = required;
